import { KatapultElement, html } from '../../mixins/katapult-element';
import { html as litHtml } from 'lit';
import { KatapultEditorTemplate } from './katapult-editor-template';
import { KatapultDialog } from '../katapult-elements/katapult-dialog.js';
import { PortalStyle } from './katapult-model-editor-style.js';
import '../katapult-firebase-worker/katapult-firebase-worker.js';
import '../katapult-elements/katapult-button.js';
import '../job-chooser/job-chooser.js';
import '../katapult-switcher/katapult-switcher.js';
import '../style-modules/paper-menu-button-style.js';
import './action-sequence-editor.js';
import { KLogic } from '../../modules/KLogic.js';
import { Timeout } from '../../modules/Timeout.js';
import { DEFAULT_SCHEMAS, SPAN_SCHEMAS } from '../../modules/KLogicSchemas.js';
import { Path } from '../../modules/Path.js';
import { ModelDefaults } from '../../modules/ModelDefaults.js';
import { GetWebAutomationData } from '../../modules/GetWebAutomationData.js';

class KatapultWebAutomationsEditor extends KatapultEditorTemplate {
  static get template() {
    return html`
      ${super.style} ${PortalStyle}
      <style include="paper-menu-button-style"></style>
      <katapult-firebase-worker
        path="photoheight/jobs/[[_itemData.preview_job]]"
        data="{{previewJobData}}"
        disabled="[[disabled]]"
      ></katapult-firebase-worker>

      <katapult-firebase-worker
        path="[[modelSpaceDetails.path]]/models/config/defaults"
        data="{{configDefaults}}"
      ></katapult-firebase-worker>

      <katapult-firebase-worker path="photoheight/web_automations_config" data="{{webAutomationsConfig}}"></katapult-firebase-worker>
      <katapult-firebase-worker path="[[modelSpaceDetails.path]]/models/attributes" data="{{otherAttributes}}"></katapult-firebase-worker>
      <katapult-firebase-worker path="[[modelSpaceDetails.path]]/models/files" data="{{companyFiles}}"></katapult-firebase-worker>

      <template is="dom-repeat" items="[[steps]]" as="step">
        <katapult-editor-step
          step$="[[step.id]]"
          creating-item="[[creatingItem]]"
          active="[[step.active]]"
          index="[[step.index]]"
          current-index="[[currentIndex]]"
          title="[[step.title]]"
        >
          <!-- Domain -->
          <template is="dom-if" if="[[equal(step.id, 'domain')]]">
            <material-icon icon="help" slot="header">
              <katapult-tooltip
                >The url to be automated. When the extension is open on this url, it will use this automation.</katapult-tooltip
              >
            </material-icon>
            <paper-table light-grey style="width: 400px;" rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <paper-input label="Domain" value="{{_itemData.domain}}" no-label-float></paper-input>
                </paper-cell>
              </paper-row>
            </paper-table>
          </template>

          <!-- Automation Type -->
          <template is="dom-if" if="[[equal(step.id, 'type')]]">
            <!-- <material-icon icon="help" slot="header">
              <katapult-tooltip
                >The url to be automated. When the extension is open on this url, it will use this automation.</katapult-tooltip
              >
            </material-icon> -->
            <paper-table light-grey style="width: 400px;" rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <katapult-drop-down
                    no-label-float
                    underline
                    label="Automation Type"
                    value="{{_itemData.type}}"
                    items="[[automationTypes]]"
                  ></katapult-drop-down>
                </paper-cell>
              </paper-row>
            </paper-table>
          </template>

          <!-- Node Filter -->
          <template is="dom-if" if="[[equal(step.id, 'node_filter')]]">
            <!-- <material-icon icon="help" slot="header">
              <katapult-tooltip
                >The url to be automated. When the extension is open on this url, it will use this automation.</katapult-tooltip
              >
            </material-icon> -->
            <paper-table light-grey rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <katapult-button
                    icon="functions"
                    iconOnly
                    size="small"
                    color="{{getKLogicButtonColor(_itemData.node_filter, nodesListError)}}"
                    on-click="openLogicEditor"
                    data-type="node_filter"
                  >
                    <katapult-tooltip>Custom Logic</katapult-tooltip>
                  </katapult-button>
                </paper-cell>
              </paper-row>
            </paper-table>
          </template>

          <!-- Preview Job Id -->
          <template is="dom-if" if="[[equal(step.id, 'preview_job')]]">
            <material-icon icon="help" slot="header">
              <katapult-tooltip>This job is used for debugging data values in the model editor.</katapult-tooltip>
            </material-icon>
            <paper-table light-grey style="width: 400px;" rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <job-chooser
                    style="--paper-input-container-underline-display: block; background-color: unset; flex-grow: 1;"
                    selected="{{_itemData.preview_job}}"
                    user-group="[[userGroup]]"
                    label="Choose a preview job"
                    no-create-new-job
                  ></job-chooser>
                </paper-cell>
              </paper-row>
            </paper-table>
          </template>

          <!-- Automation Type -->
          <template is="dom-if" if="[[equal(step.id, 'preview_node')]]">
            <!-- <material-icon icon="help" slot="header">
              <katapult-tooltip
                >The url to be automated. When the extension is open on this url, it will use this automation.</katapult-tooltip
              >
            </material-icon> -->
            <paper-table light-grey style="width: 400px;" rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <katapult-drop-down
                    no-label-float
                    underline
                    label="Preview Node"
                    value="{{_itemData.preview_node}}"
                    items="[[getNodeList(previewJobData.nodes, _itemData.node_filter)]]"
                    label-path="label"
                    value-path="key"
                  ></katapult-drop-down>
                </paper-cell>
              </paper-row>
            </paper-table>
          </template>

          <!-- Data -->
          <template is="dom-if" if="[[equal(step.id, 'data')]]">
            <paper-table rounded outline grow slot="body" overflow-hidden dividers>
              <paper-table-scroll data-path="_itemData.data" on-sort-changed="orderedItemsArraySortChanged">
                <paper-row grey short slot="before">
                  <paper-cell icon>
                    <material-icon icon="swap_vert"></material-icon>
                  </paper-cell>
                  <paper-cell style="flex-grow: 2">Name</paper-cell>
                  <paper-cell center style="flex-grow: 1">Logic</paper-cell>
                  <paper-cell style="flex-grow: 6">Value</paper-cell>
                  <paper-cell shrink style="width: 80px"></paper-cell>
                </paper-row>
                <template is="dom-repeat" items="[[getOrderedItemsArray(_itemData.data)]]" mutable-data as="data">
                  <paper-header-content white divider no-click-row slot="sortable">
                    <paper-cell slot="header" icon drag-handle>[[add(index, 1)]]</paper-cell>
                    <paper-cell slot="header" style="flex-grow: 2">
                      <paper-input
                        no-label-float
                        underline
                        label="Name"
                        value="{{data.name}}"
                        on-value-changed="updateProperty"
                        data-path="_itemData.data.$(model.data.$key).name"
                        allowed-pattern="^[^.]+$"
                      ></paper-input>
                    </paper-cell>
                    <paper-cell slot="header" center style="flex-grow: 1">
                      <katapult-button
                        icon="functions"
                        iconOnly
                        size="small"
                        color="{{getKLogicButtonColor(data.logic, false, previewValues, data.$key)}}"
                        on-click="openLogicEditor"
                        data-type="data"
                      >
                        <katapult-tooltip>Custom Logic</katapult-tooltip>
                      </katapult-button>
                    </paper-cell>
                    <paper-cell
                      slot="header"
                      style="flex-grow: 6; overflow:hidden; text-wrap:nowrap; color:rgba(66, 66, 66, 0.6); user-select:text;"
                      title="[[getPreviewValue(previewValues, data.$key)]]"
                      >[[getPreviewValue(previewValues, data.$key)]]</paper-cell
                    >
                    <paper-cell slot="header" shrink>
                      <paper-menu-button class="manage-item-button" horizontal-align="right" vertical-align="top" vertical-offset="48">
                        <katapult-button iconOnly noBorder slot="dropdown-trigger" icon-button icon="more_vert"></katapult-button>
                        <div slot="dropdown-content">
                          <div
                            flex
                            align-center
                            style="padding: 12px; gap: 8px; position: relative; cursor: pointer;"
                            data-path="_itemData.data.$(model.data.$key)"
                            data-value="$null"
                            on-click="updateProperty"
                          >
                            <paper-ripple></paper-ripple>
                            <material-icon icon="delete"></material-icon>
                            <div>Delete Data</div>
                          </div>
                        </div>
                      </paper-menu-button>
                    </paper-cell>
                    <div slot="content">
                      <!-- Error Messages -->
                      <paper-table rounded outline grow slot="body" overflow-hidden dividers style="margin:10px 20px;">
                        <paper-table-scroll
                          data-path="_itemData.data.$(model.data.$key).error_messages"
                          on-sort-changed="orderedItemsArraySortChanged"
                        >
                          <paper-row grey short slot="before">
                            <paper-cell icon>
                              <material-icon icon="swap_vert"></material-icon>
                            </paper-cell>
                            <paper-cell style="flex-grow: 2">Error Type</paper-cell>
                            <paper-cell center style="flex-grow: 1">Error Logic</paper-cell>
                            <paper-cell style="flex-grow: 6">Error Text</paper-cell>
                            <paper-cell shrink style="width: 80px"></paper-cell>
                          </paper-row>
                          <template is="dom-repeat" items="[[getOrderedItemsArray(data.error_messages)]]" mutable-data>
                            <paper-row tall white slot="sortable">
                              <paper-cell icon drag-handle>[[add(index, 1)]]</paper-cell>
                              <paper-cell style="flex-grow: 2">
                                <katapult-drop-down
                                  no-label-float
                                  underline
                                  label="Error Type"
                                  value="{{item.type}}"
                                  items="[[errorTypes]]"
                                  on-value-changed="updateProperty"
                                  data-path="_itemData.data.$(model.parentModel.data.$key).error_messages.$(model.item.$key).type"
                                ></katapult-drop-down>
                              </paper-cell>
                              <paper-cell center style="flex-grow: 1">
                                <katapult-button
                                  icon="functions"
                                  iconOnly
                                  size="small"
                                  color="{{getKLogicButtonColor(item.logic)}}"
                                  on-click="openLogicEditor"
                                  data-type="error_messages"
                                >
                                  <katapult-tooltip>Custom Logic</katapult-tooltip>
                                </katapult-button>
                              </paper-cell>
                              <paper-cell style="flex-grow: 6;">
                                <paper-input
                                  no-label-float
                                  underline
                                  label="Error Text"
                                  value="{{item.text}}"
                                  on-value-changed="updateProperty"
                                  data-path="_itemData.data.$(model.parentModel.data.$key).error_messages.$(model.item.$key).text"
                                ></paper-input>
                              </paper-cell>
                              <paper-cell shrink>
                                <paper-menu-button
                                  class="manage-item-button"
                                  horizontal-align="right"
                                  vertical-align="top"
                                  vertical-offset="48"
                                >
                                  <katapult-button iconOnly noBorder slot="dropdown-trigger" icon-button icon="more_vert"></katapult-button>
                                  <div slot="dropdown-content">
                                    <div
                                      flex
                                      align-center
                                      style="padding: 12px; gap: 8px; position: relative; cursor: pointer;"
                                      data-path="_itemData.data.$(model.parentModel.data.$key).error_messages.$(model.item.$key)"
                                      data-value="$null"
                                      on-click="updateProperty"
                                    >
                                      <paper-ripple></paper-ripple>
                                      <material-icon icon="delete"></material-icon>
                                      <div>Delete Error</div>
                                    </div>
                                  </div>
                                </paper-menu-button>
                              </paper-cell>
                            </paper-row>
                          </template>
                          <paper-row class="addButton" light-grey short slot="after">
                            <paper-cell ripple data-path="_itemData.data.$(model.data.$key).error_messages" on-click="addOrderedItem">
                              <material-icon icon="playlist_add"></material-icon>
                              <div>Add Error</div>
                            </paper-cell>
                          </paper-row>
                        </paper-table-scroll>
                      </paper-table>
                    </div>
                  </paper-header-content>
                </template>
                <paper-row class="addButton" light-grey short slot="after">
                  <paper-cell ripple data-path="_itemData.data" on-click="addOrderedItem">
                    <material-icon icon="playlist_add"></material-icon>
                    <div>Add Data</div>
                  </paper-cell>
                </paper-row>
              </paper-table-scroll>
            </paper-table>
          </template>

          <!-- Action Sequence -->
          <template is="dom-if" if="[[equal(step.id, 'action_sequence')]]">
            <action-sequence-editor
              grow
              slot="body"
              other-attributes="[[otherAttributes]]"
              sequence="{{_itemData.action_sequence}}"
              data-items="[[getDataItems(_itemData.data)]]"
              automation-type="[[_itemData.type]]"
              configured-options="[[configuredOptions]]"
              preview-values="[[previewValues]]"
            ></action-sequence-editor>
          </template>
        </katapult-editor-step>
      </template>
      ${super.createItemContainer}
    `;
  }

  static get properties() {
    return {
      errorTypes: {
        type: Array,
        value: () => ['Warning', 'Error']
      },
      automationTypes: {
        type: Array,
        value: () => ['Job', 'Node']
      },
      modelDefaults: {
        type: Object,
        computed: 'computeModelDefaults(configDefaults, otherAttributes)',
        value: () => ModelDefaults()
      },
      previewValues: {
        type: Object,
        value: () => ({})
      },
      configuredOptions: {
        type: Object,
        computed: 'computeConfiguredOptions(webAutomationsConfig, _itemData.domain)'
      }
    };
  }

  static get observers() {
    return [
      'computePreviewValues(_itemData, previewJobData, companyFiles, userGroup, _itemData.type, _itemData.preview_node, _itemData.data.*)'
    ];
  }

  ready() {
    super.ready();

    this.keyMatchLabel = true;

    // An ordered list of all possible steps.
    this.setSteps([
      {
        id: 'domain',
        title: 'Domain',
        trigger: () => this.get('_itemData.domain') != null
      },
      {
        id: 'type',
        title: 'Automation Type',
        trigger: () => this.get('_itemData.type') != null
      },
      {
        id: 'node_filter',
        title: 'Node Filter',
        trigger: () => this.get('_itemData.node_filter') != null,
        if: () => this.get('_itemData.type') == 'Node'
      },
      {
        id: 'preview_job',
        title: 'Preview Job',
        trigger: () => this.get('_itemData.preview_job') != null
      },
      {
        id: 'preview_node',
        title: 'Preview Node',
        trigger: () => this.get('_itemData.preview_node') != null,
        if: () => this.get('_itemData.type') == 'Node'
      },
      {
        id: 'data',
        title: 'Data',
        trigger: () => this.get('_itemData.data') != null
      },
      {
        id: 'action_sequence',
        title: 'Action Sequence',
        trigger: () => this.get('_itemData.action_sequence') != null
      }
    ]);
  }

  computeModelDefaults(configDefaults, otherAttributes) {
    return ModelDefaults(configDefaults, otherAttributes);
  }

  computeConfiguredOptions(webAutomationsConfig, domain) {
    const options = {};
    for (const prop in webAutomationsConfig) {
      for (const key in webAutomationsConfig[prop]) {
        if (webAutomationsConfig[prop][key].includes(domain)) {
          options[prop] = true;
        }
      }
    }
    return options;
  }

  getNodeList(nodes, nodeFilter) {
    this.nodesListError = false;
    return nodes
      ? Object.keys(nodes)
          .filter((nodeId) => {
            try {
              return KLogic.compute(nodeFilter, {
                job: this.previewJobData,
                node: nodes[nodeId],
                user: { email: window.katapultAuth?.user?.email }
              });
            } catch (e) {
              console.error(e);
              this.nodesListError = true;
              return false;
            }
          })
          .map((key) => ({
            key,
            label:
              Path.get(nodes, `${key}.attributes.${this.modelDefaults.ordering_attribute}.*`) ||
              `(No ${this.modelDefaults.ordering_attribute_label})`
          }))
      : [];
  }

  async computePreviewValues(itemData, previewJobData, companyFiles, userGroup) {
    let values = await GetWebAutomationData(itemData, previewJobData, companyFiles, userGroup, this.otherAttributes);
    this.set('previewValues', values?.dataValues);
    this.set('kLogicDataset', values?.dataset);
  }

  getPreviewValue(previewValues, key) {
    let val = previewValues?.[key]?.value;
    if (Array.isArray(val?.files)) val = val.files.map((file) => file.name).join(', ');
    return JSON.stringify(val);
  }

  getKLogicButtonColor(data, error, previewValues, key) {
    if (error || previewValues?.[key]?.value == '(Logic Error)') return 'var(--paper-red-500)';
    if (typeof data === 'object' && !Array.isArray(data) && data !== null) return 'var(--secondary-color)';
    return 'white';
  }

  async openLogicEditor(e) {
    const button = e.currentTarget;
    button.loading = true;
    await Timeout(100);
    const type = button.dataset.type;
    const config = {
      schema: {
        job: DEFAULT_SCHEMAS.JOB,
        user: DEFAULT_SCHEMAS.USER,
        connection_lookup: DEFAULT_SCHEMAS.CONNECTION_LOOKUP,
        company_files: {},
        job_files: {},
        all_node_files: { $wild: {} },
        attacher_info: {},
        spans_node_list: SPAN_SCHEMAS.SPANS_NODE_LIST
      },
      type: 'JOB_WEB_AUTOMATIONS'
    };

    if (this._itemData.type == 'Node') {
      config.schema.node = DEFAULT_SCHEMAS.NODE;
      config.schema.node_id = 'text';
      config.schema.node_files = {};
      config.schema.spans_attributes = SPAN_SCHEMAS.SPANS;
      config.type = 'NODE_WEB_AUTOMATIONS';
    }

    for (const key in this.companyFiles) {
      config.schema.company_files[this.companyFiles[key].name.replace(/\./g, ' ')] = 'object';
    }
    for (const attribute in this.otherAttributes) {
      if (this.otherAttributes[attribute].gui_element == 'file') {
        if (this.otherAttributes[attribute].attribute_types?.includes('node')) {
          if (this._itemData.type == 'Node') {
            config.schema.node_files[attribute] = 'object';
          }
          config.schema.all_node_files.$wild[attribute] = 'object';
        }
        if (this.otherAttributes[attribute].attribute_types?.includes('job')) {
          config.schema.job_files[attribute] = 'object';
        }
      }
    }
    switch (type) {
      case 'node_filter':
        config.path = '_itemData.node_filter';
        config.label = 'Node Filter';
        config.schema.node = DEFAULT_SCHEMAS.NODE;
        config.schema.node_id = 'text';
        break;
      case 'data':
        config.path = `_itemData.data.${e.model.data.$key}.logic`;
        config.label = e.model.data.name ?? 'Data';
        break;
      case 'error_messages':
        config.path = `_itemData.data.${e.model.parentModel.data.$key}.error_messages.${e.model.item.$key}.logic`;
        config.label = e.model.item.type ?? 'Error';
        break;
    }

    if (type != 'node_filter') {
      const currentOrder = e.model.parentModel?.data?.order ?? e.model.data.order;
      this.getOrderedItemsArray(this._itemData?.data).forEach((item) => {
        if (item.name && (item.order < currentOrder || (item.order == currentOrder && type == 'error_messages'))) {
          Path.set(config, `schema.data.${item.name}`, 'text');
        }
      });
    }

    const existingEditorData = JSON.parse(JSON.stringify(this.get(config.path) || {}));

    const dialog = KatapultDialog.open({
      dialog: {
        title: `Custom Logic for ${config.label}`,
        draggable: true
      },
      template: () => litHtml`
      <div>
        <k-logic-editor expand-editor></k-logic-editor>
      </div>
      <div slot="buttons">
        <katapult-button dialog-dismiss>Cancel</katapult-button>
        <katapult-button id="confirm" color="var(--secondary-color)" dialog-confirm>Done</katapult-button>
      </div>
      `
    });
    await dialog.openStart;
    // Get the confirm button.
    const confirmButton = dialog.querySelector('#confirm');
    // get data from the editor
    confirmButton.addEventListener('click', async () => {
      this.updateProperty(new CustomEvent('update-item', { detail: { path: config.path, value: editor.block } }));
      dialog.close();
    });
    // Get the k-logic-editor
    const editor = dialog.querySelector('k-logic-editor');
    // set existing data on the editor so that when we open the dialog the editor has the right data
    editor.block = existingEditorData;

    // set the schema for the k-logic editor
    editor.schema = config.schema;
    this.jobList ??= this.userGroup
      ? await FirebaseWorker.ref(`photoheight/job_permissions/${this.userGroup}/list`)
          .orderByChild('status')
          .equalTo('active')
          .once('value')
          .then((s) => s.val())
      : null;
    editor.debugReferenceData = {
      user: { email: globalThis.katapultAuth?.user?.email },
      data: this.kLogicDataset.data,
      jobs: this.jobList
    };
    editor.kLogicType = config.type;
    await editor.setupDebugging();
    if (this._itemData?.preview_job) editor.debugInputChanged({ detail: { value: this._itemData.preview_job }, model: { index: 0 } });
    if (this._itemData?.preview_node) editor.debugInputChanged({ detail: { value: this._itemData.preview_node }, model: { index: 1 } });
    button.loading = false;
  }

  getDataItems(data) {
    return Object.keys(data ?? {})
      .filter((x) => data[x])
      .map((key) => ({ key, label: data[key].name }));
  }

  beforeSave() {
    this.cleanupActionSequence(this._itemData?.action_sequence);
  }

  cleanupActionSequence(sequence) {
    const defaultProps = ['action', 'order', 'description', 'show_description'];
    const propertyRequirements = {
      selector: {
        action: ['input_value', 'output_value', 'trigger_event', 'conditional_block']
      },
      selector_type: {
        action: ['input_value', 'output_value', 'trigger_event', 'conditional_block']
      },
      time: {
        action: 'wait'
      },
      value_type: {
        action: ['input_value', 'print', 'error']
      },
      description: { show_description: true },
      attribute: {
        action: 'output_value'
      },
      data: {
        value_type: ['Data', 'Loop Item'],
        location_type: 'Loop Item',
        action: 'loop_block'
      },
      text: {
        action: ['trigger_event', 'print', 'error', 'navigate_to_url', 'select_frame'],
        value_type: 'Text'
      },
      query_selector_chain: {
        selector_type: 'Chain'
      },
      output_logic: {
        action: 'output_value'
      },
      conditional_logic: {
        action: 'conditional_block'
      },
      location_type: {
        action: 'output_value'
      },
      property: {
        action: 'conditional_block'
      },
      operator: {
        action: 'conditional_block'
      },
      value: {
        action: 'conditional_block'
      },
      sequence: {
        action: ['conditional_block', 'loop_block']
      },
      label: {
        action: 'loop_block'
      }
    };
    Object.values(sequence ?? {}).forEach((item) => {
      for (const prop in item) {
        if (defaultProps.includes(prop)) continue;
        if (
          !propertyRequirements[prop] ||
          !Object.entries(propertyRequirements[prop]).some(([key, value]) => value?.includes?.(item[key]) || value == item[key])
        ) {
          delete item[prop];
        }
        if (['selector_type', 'query_selector_chain'].includes(prop) && !this.configuredOptions?.domains_to_select_by_label) {
          delete item[prop];
        }
      }
      if (item?.action == 'conditional_block') {
        this.cleanupActionSequence(item.sequence);
      }
    });
  }
}

customElements.define('katapult-web-automations-editor', KatapultWebAutomationsEditor);
